export default "__VITE_ASSET__DiP7bXf3__"